import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-static'

import { adminUpdate } from '../../firebase'

import AdminValidate from './AdminValidate'

const Wrapper = styled.div`
  color: ${props => props.theme.main.bg};

  .title.is-3, code {
    display: block;
    margin-bottom: 1em;
  }
`

export default class AdminEditListen extends React.Component {
  constructor (props) {
    super(props)
    const link = props.data.val()
    this.state = {
      order: link.order,
      title: link.title,
      titleValid: true,
      url: link.url,
      urlValid: true,
    }
    this.handleFormChange = this.handleFormChange.bind(this)
    this.validate = this.validate.bind(this)
    this.validateForm = this.validateForm.bind(this)
    this.update = this.update.bind(this)
  }

  handleFormChange (e) {
    const name = e.target.name
    const value = e.target.value
    this.setState({ [name]: value },
      () => this.validate(name, value))
  }

  validate (name, value) {
    const field = `${name}Valid`
    this.setState({ [field]: value.length > 0 })
  }

  validateForm () {
    const formValid = this.state.titleValid && this.state.urlValid
    this.update(formValid)
  }

  update (formValid) {
    if (!formValid) {
      return alert('Complete the highlighted fields.')
    }
    const { title, url, order } = this.state
    const data = {
      title,
      url,
      order,
    }
    adminUpdate(this.props.refUrl, data, this.props.showSuccessModal, this.props.successRedirect, 'listen')
  }

  render () {
    const { errorClass } = this.props
    const { title, titleValid, url, urlValid } = this.state
    return (
      <Wrapper className="column">
        <h3 className="title is-3">Audio Link</h3>
        <div className="content">
          <h5 className="title is-5">Title</h5>
          <AdminValidate
            className="field"
            valid={titleValid}
            message="Add a title">
            <div className="control">
              <input className={`input title-input ${errorClass(titleValid)}`}
                type="text"
                value={title}
                name="title"
                onChange={this.handleFormChange} />
            </div>
          </AdminValidate>
        </div>
        <div className="content">
          <h5 className="title is-5">Embed Link</h5>
          <p>Paste in embed code from soundcloud, youtube or vimeo - for example:</p>
          <code>&lt;iframe width="560" height="315" src="https://www.youtube.com/embed/VvCsrjPQ5gA?rel=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen&gt;&lt;/iframe&gt;</code>
          <AdminValidate
            className="field"
            valid={urlValid}
            message="Add an embed link">
            <div className="control">
              <input className={`input url-input ${errorClass(urlValid)}`}
                type="text"
                value={url}
                name="url"
                onChange={this.handleFormChange} />
            </div>
          </AdminValidate>
        </div>
        <div className="content">
          <div className="field is-grouped">
            <div className="control">
              <button className="button is-success" onClick={this.validateForm}>Update</button>
            </div>
            <div className="control">
              <Link to="/admin/listen" className="button is-link">Cancel</Link>
            </div>
          </div>
        </div>
      </Wrapper>
    )
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/admin/AdminEditListen.js